import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { TrendingUp } from 'lucide-react';

export default function RetrySuccessChart({ data }) {
  if (!data?.retryDistribution || data?.retryDistribution?.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex items-center mb-4">
          <TrendingUp className="w-6 h-6 text-green-600 mr-2" />
          <h3 className="text-lg font-semibold text-gray-900">Taux de Succès des Relances</h3>
        </div>
        <p className="text-gray-500 text-center py-8">Aucune donnée de relance disponible</p>
      </div>
    );
  }

  const chartData = data?.retryDistribution?.map(item => ({
    name: `Retry ${item?.retryCount}`,
    Succès: item?.success,
    Échecs: item?.failed,
    'Taux de Succès': parseFloat(item?.successRate)
  }));

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center">
          <TrendingUp className="w-6 h-6 text-green-600 mr-2" />
          <h3 className="text-lg font-semibold text-gray-900">Taux de Succès des Relances</h3>
        </div>
        <div className="text-sm text-gray-600">
          <span className="font-medium">{data?.successRate}%</span> de succès global
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4 mb-6">
        <div className="bg-blue-50 rounded-lg p-3">
          <p className="text-xs text-gray-600">Total Relances</p>
          <p className="text-2xl font-bold text-blue-600">{data?.totalRetries}</p>
        </div>
        <div className="bg-green-50 rounded-lg p-3">
          <p className="text-xs text-gray-600">Succès</p>
          <p className="text-2xl font-bold text-green-600">{data?.successfulRetries}</p>
        </div>
        <div className="bg-red-50 rounded-lg p-3">
          <p className="text-xs text-gray-600">Échecs</p>
          <p className="text-2xl font-bold text-red-600">{data?.failedRetries}</p>
        </div>
      </div>

      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="Succès" fill="#10b981" />
          <Bar dataKey="Échecs" fill="#ef4444" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}